import { Typography, styled } from "@mui/material";

const OperationTypographyInstruction = styled(Typography)(({ theme }) => ({
    fontWeight: 450,
    fontSize: "1.5rem",
}));

export default OperationTypographyInstruction